export default function mapStateToProps(state, ownProps) {
  const prop1 = state.auth.isAuthUser;
  const prop2 = ownProps.type;
  const prop3 = state.auth.client_id;
  const prop4 = state.auth.user_full_name;
  return {
    isAuthUser: prop1,
    type: prop2,
    client_id: prop3,
    user_full_name: prop4,
  };
}

export function mapLoginStateToProps(state, ownProps) {
  console.log("login mapping properties", ownProps);
  console.log("login mapping state", state);
  const prop1 = state.auth.isAuthUser;
  const prop2 = state.error;
  return { isAuthUser: prop1, error: prop2 };
}

export function mapVtrStateToProps(state, ownProps) {
  console.log("vtr mapping properties", ownProps);
  console.log("vtr state properties", state);
  const prop1 = state.vtrList.trips;
  const prop2 = state.auth;
  const prop3 = state.validation;
  const vtrTrip = state.vtrTrip;
  const prop6 = state.helpText;
  const errors = state.error;
  const prop7 = state.vtrList.isLoaded;
  const prop8 = state.vtrList.error;
  return {
    trips: prop1,
    listLoaded: prop7,
    listError: prop8,
    auth: prop2,
    validations: prop3,
    vtrTrip: vtrTrip,
    helpText: prop6,
    error: errors,
    actions: {},
  };
}

export function mapUserDetailStateToProps(state, ownProps) {
  const prop1 = state.auth.isAuthUser;
  const prop2 = state.auth.client_id;
  const prop3 = state.auth.token;
  const prop4 = state.auth.token_expires;
  const prop5 = state.auth.user_app_status;
  const prop6 = state.auth.user_full_name;
  return {
    isAuthUser: prop1,
    client_id: prop2,
    token: prop3,
    token_expires: prop4,
    user_app_status: prop5,
    user_full_name: prop6,
  };
}

export function mapIvrStateToProps(state, ownProps) {
  console.log("ivr mapping state", state);
  console.log("ivr mapping properties", ownProps);
  const prop1 = state.ivrList.trips;
  const prop2 = state.auth;
  const prop3 = state.ivrList.errors;
  const prop4 = state.error;
  return { ivrs: prop1, auth: prop2, errors: prop3, apiErrors: prop4 };
}
